import createContextUtilities from '../../utils/createContextUtilities/3841674170c200f7bdd32cb74e68b517c71ba9e78ccd1beac3d76de81e3e2a5c.cfe-internal.js';

var _createContextUtiliti = createContextUtilities({}),
    ModalContextProvider = _createContextUtiliti.Provider,
    useModalContext = _createContextUtiliti.useContext;
var useModalContext$1 = useModalContext;

export { ModalContextProvider, useModalContext$1 as default };
